export const USER_LOGGED_OUT = '0';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_ACCESS_DETAILS = 'USER_ACCESS_DETAILS';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';

export const SET_OFFLINE = 'SET_OFFLINE';

export const SPINNER_COUNTER = 'SPINNER_COUNTER';

export const SET_DASHBOARD_VIEW = 'SET_DASHBOARD_VIEW';